<template>
  <div
      class="order-status"
      :class="'order-status-' + orderStatus.replaceAll(' ', '-').toLowerCase()">
    {{ orderStatus }}
  </div>
</template>

<script>
export default {
  name: "OrderStatus",
  props: {
    orderStatus: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style>
.order-status {
  margin: 4px;
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  background: #eaeaea;
  width: fit-content;
}

.order-status-processing,
.order-status-planning,
.order-status-waiting-for-updates {
  background: #f0ecf9 !important;
  color: #4d11f1 !important;
}

.order-status-received,
.order-status-complete {
  background: #eff8fc !important;
  color: #1476ad !important;
}

.order-status-canceled,
.order-status-cancelled,
.order-status-invalid,
.order-status-unfulfillable {
  background: #fcefef !important;
  color: #d4231a !important;
}

.order-status-complete-partialled {
  background: #fdefe6 !important;
  color: #f1670d !important;
}
</style>
